import styled from 'styled-components'
import { Flex } from 'components/common/styles'

export const StyledLookupSingleTable = styled(Flex)`
  overflow: hidden;
  height: 100%;
`
